import { needsBudget } from './service.js'

/**
 * One question per screen, and the order they are asked in.
 *
 * The old form asked everything across two dense screens. This asks nine things across
 * nine, and that is not a smaller form — it is the same form with one thing on the page
 * at a time. The customer this is for reads slowly and loses their place, and a screen
 * holding a single question cannot be lost in.
 *
 * **Steps are named, not numbered.** Padala has no budget step, so a number would mean
 * two different things depending on the service, and every piece of code touching a step
 * would have to know which. The stepper works out its own display numbers from this
 * array.
 */
export const STEP = {
  SERVICE: 'service',
  PICKUP: 'pickup',
  PICKUP_CONTACT: 'pickupContact',
  ITEMS: 'items',
  BUDGET: 'budget',
  DROPOFF: 'dropoff',
  TIMING: 'timing',
  PAYMENT: 'payment',
  SUMMARY: 'summary',
}

const ORDER = [
  STEP.SERVICE,
  STEP.PICKUP,
  STEP.PICKUP_CONTACT,
  STEP.ITEMS,
  STEP.BUDGET,
  STEP.DROPOFF,
  STEP.TIMING,
  STEP.PAYMENT,
  STEP.SUMMARY,
]

/** Steps the customer may pass without answering. Both have a Skip as large as Continue. */
export const OPTIONAL_STEPS = new Set([STEP.PICKUP_CONTACT, STEP.TIMING])

/**
 * The screens this order actually has.
 *
 * Nine for pabili — eight questions and the summary. Eight for padala, which has nothing
 * to buy and so has no budget to set.
 *
 * @param {object} state
 * @returns {string[]}
 */
export function stepsFor(state) {
  return ORDER.filter((step) => step !== STEP.BUDGET || needsBudget(state))
}
